module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register_container"
  }, [_c('div', {
    staticClass: "markBox"
  }), _vm._v(" "), _c('div', {
    ref: "registerBox",
    staticClass: "register"
  }, [(_vm.obj.isZXQudao) ? _c('img', {
    staticClass: "title_reg",
    attrs: {
      "src": require("../../image/zx-mll.png")
    }
  }) : (_vm.obj.isZXBZJPQudao) ? _c('img', {
    staticClass: "title_reg",
    attrs: {
      "src": require("../../image/zxzw-bzjp-mll.png")
    }
  }) : (_vm.obj.isQudao) ? _c('img', {
    staticClass: "title_reg",
    attrs: {
      "src": require("../../image/newnew-reg.png")
    }
  }) : (!_vm.obj.isQian) ? _c('img', {
    staticClass: "title_reg",
    attrs: {
      "src": require("../../image/mll-register.png")
    }
  }) : _c('img', {
    staticClass: "title_reg",
    attrs: {
      "src": require("../../image/jieqianmll.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fromBox"
  }, [_c('div', {
    staticClass: "fromBox_head"
  }, [_c('span', {
    staticClass: "cbb"
  }, [_vm._v(_vm._s(_vm.quhao))]), _vm._v(" "), _c('span', {
    staticClass: "c4",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.getCountry($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.guojia))])]), _vm._v(" "), _c('div', {
    staticClass: "inputBox phoneBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNum),
      expression: "phoneNum"
    }],
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": "输入手机号"
    },
    domProps: {
      "value": (_vm.phoneNum)
    },
    on: {
      "blur": _vm.inputBlurHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNum = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isGet) ? _c('div', {
    staticClass: "inputBox phoneBox"
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.sendCodeBtn($event)
      }
    }
  }, [_vm._v("获取验证码")])]) : _vm._e(), _vm._v(" "), (!_vm.isGet) ? _c('div', {
    staticClass: "inputBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "codeText",
    attrs: {
      "type": "text",
      "name": "验证码",
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "blur": _vm.inputBlurHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.changeBtn) ? _c('button', {
    staticClass: "codeBtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.sendCode($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t重新获取\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.changeBtn) ? _c('button', {
    staticClass: "codeBtn daoshuBtn"
  }, [_vm._v(_vm._s(_vm.codeNum + 's'))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xieyiBox"
  }, [_c('span', {
    staticClass: "service-check-box",
    class: {
      active: _vm.isChecked
    },
    on: {
      "click": _vm.changCheck
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "xieyi hui"
  }, [_vm._v("我已同意")]), _vm._v(" "), _c('span', {
    staticClass: "xieyi",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.gotoLink($event)
      }
    }
  }, [_vm._v("《易起问用户协议》")])]), _vm._v(" "), (_vm.obj.isQian) ? _c('button', {
    staticClass: "bindBtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.bindEvent($event)
      }
    }
  }, [_c('span', [_vm._v("大师免费解签")])]) : _c('button', {
    staticClass: "bindBtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.bindEvent($event)
      }
    }
  }, [_c('span', [_vm._v("马上提交")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.batchObj.isShow) ? _c('newUserPopLink', {
    attrs: {
      "newUserObj": _vm.batchObj
    },
    on: {
      "close": _vm.newUserCloseLink
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isCountry) ? _c('countrycom', {
    on: {
      "change": _vm.changeCode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAgree) ? _c('agreement', {
    on: {
      "close": function($event) {
        _vm.isAgree = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b39cbae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b39cbae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/newRegisterV2.vue
// module id = 416
// module chunks = 32